import { render, staticRenderFns } from "./MoviesPagination.vue?vue&type=template&id=41e2044f&scoped=true&"
import script from "./MoviesPagination.vue?vue&type=script&lang=js&"
export * from "./MoviesPagination.vue?vue&type=script&lang=js&"
import style0 from "./MoviesPagination.vue?vue&type=style&index=0&id=41e2044f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e2044f",
  null
  
)

export default component.exports